window.initProductTabs ?? (() => {
  window.initProductTabs = (section_id) => {
    console.log(section_id);
    const tabs = document.querySelectorAll(`#shopify-section-${section_id} .tab-trigger`);
    const tabs_contents = document.querySelectorAll(`#shopify-section-${section_id} .tab-content`);

    const showTabContent = (event) => {
        console.log(event);
        console.log(event.currentTarget.dataset.index);

        if(!event.currentTarget.classList.contains('active')) {
            tabs.forEach(tab => {
                tab.classList.remove('active');
            });
            event.currentTarget.classList.add('active');

            tabs_contents.forEach(tab_content => {
                if(tab_content.dataset.index == event.currentTarget.dataset.index) {
                    tab_content.classList.add('active');
                } else {
                    tab_content.classList.remove('active');
                }
                
            });
        }
    }

    tabs.forEach(tab => {
        tab.addEventListener('click', showTabContent);
    });

}
})();